var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      class: ["box-card", _vm.optStatusEdit ? "" : "not-click"],
      staticStyle: { height: "25%" }
    },
    [
      _c(
        "div",
        {
          staticStyle: { padding: "2px 0" },
          attrs: { slot: "header" },
          slot: "header"
        },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("SystemMaintenance.WarningSettings")))
          ])
        ]
      ),
      _c(
        "el-form",
        {
          staticStyle: { width: "100%" },
          attrs: {
            disabled: !_vm.optStatusEdit,
            "label-position": "left",
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SystemMaintenance.WarningSwitch") } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.sopWarningConfig.open,
                    callback: function($$v) {
                      _vm.$set(_vm.sopWarningConfig, "open", $$v)
                    },
                    expression: "sopWarningConfig.open"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: true } }, [
                    _vm._v(_vm._s(_vm.$t("SystemMaintenance.TurnOnWarning")))
                  ]),
                  _c("el-radio", { attrs: { label: false } }, [
                    _vm._v(_vm._s(_vm.$t("SystemMaintenance.TurnOffWarning")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("CargoMsg.Cargo_EarlyWarning") } },
            [
              _c(
                "el-select",
                {
                  model: {
                    value: _vm.sopWarningConfig.warningDateField,
                    callback: function($$v) {
                      _vm.$set(_vm.sopWarningConfig, "warningDateField", $$v)
                    },
                    expression: "sopWarningConfig.warningDateField"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      value: 0,
                      label: _vm.$t("SystemMaintenance.SailingTimeETD")
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 1,
                      label: _vm.$t("SystemMaintenance.ArrivalTimeETA")
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 2,
                      label: _vm.$t("SystemMaintenance.OpenPortTime")
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 3,
                      label: _vm.$t("SystemMaintenance.ClosingPortTime")
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 4,
                      label: _vm.$t("SystemMaintenance.ClosingTimeForOrders")
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 5,
                      label: _vm.$t("SystemMaintenance.CustomsClosingTime")
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 6,
                      label: _vm.$t("SystemMaintenance.ScheduledBerthingDate")
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 7,
                      label: _vm.$t("SystemMaintenance.ScheduledDepartureDate")
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SystemMaintenance.WarningTime") } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px" },
                  model: {
                    value: _vm.sopWarningConfig.warningType,
                    callback: function($$v) {
                      _vm.$set(_vm.sopWarningConfig, "warningType", $$v)
                    },
                    expression: "sopWarningConfig.warningType"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      value: 0,
                      label: _vm.$t("SystemMaintenance.Advance")
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      value: 1,
                      label: _vm.$t("SystemMaintenance.Delay")
                    }
                  })
                ],
                1
              ),
              _c("el-input", {
                staticStyle: { width: "50px" },
                model: {
                  value: _vm.sopWarningConfig.warningHour,
                  callback: function($$v) {
                    _vm.$set(_vm.sopWarningConfig, "warningHour", $$v)
                  },
                  expression: "sopWarningConfig.warningHour"
                }
              }),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("SystemMaintenance.HoursWarningReminder")))
              ])
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("queryJob.warningLevel") } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.sopWarningConfig.warningLevel,
                    callback: function($$v) {
                      _vm.$set(_vm.sopWarningConfig, "warningLevel", $$v)
                    },
                    expression: "sopWarningConfig.warningLevel"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("SystemMaintenance.Highest")))
                  ]),
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("SystemMaintenance.High")))
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("SystemMaintenance.Medium")))
                  ]),
                  _c("el-radio", { attrs: { label: 3 } }, [
                    _vm._v(_vm._s(_vm.$t("SystemMaintenance.Low")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }